import { productionTransactionBeforeSave } from "services/sosInventoryService/productionTransaction/beforeSave";
import {
  normalizeLot,
  lotSerialNormalizationForFinishedGoods,
} from "services/utility/beforeSave";
import { convertNativeToCustom } from "services/utility/customFields";

import globalState from "globalState/globalState";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  const { buildHasNextRefNumberSet } =
    globalState.getState().userCompanySettings.settings;

  const newRecord = productionTransactionBeforeSave(
    OBJECT_TYPES.BUILD.fullString,
    record
  );

  // Remove "auto" from number field when auto-numbering is not set
  if (!buildHasNextRefNumberSet && newRecord.number === "auto") {
    newRecord.number = "";
  }

  // for each line
  const newOutputs = [];
  newRecord.outputs.forEach((output) => {
    let newOutput = { ...output };
    newOutput.lot = normalizeLot(newOutput.lot);
    newOutput = lotSerialNormalizationForFinishedGoods(
      newOutput,
      record.workcenter
    );
    newOutputs.push(newOutput);
  });

  // update the record with the new lines
  newRecord.outputs = newOutputs;

  newRecord.customFields = convertNativeToCustom(record.customFields);

  return newRecord;
}
